import React from 'react'

export default function TechnologyHead({ data }) {

  return (
    <>
      <section className='tech-head'>
        <div className='container'>
          <div className='row'>
            <div className='col-lg-10'>
              <span>{data.label}</span>
              <h1 className='heading'>{data?.heading}</h1>
            </div>

            <div className='col-lg-12'>
              <img src={data.img} alt={data.alt} />
              <div dangerouslySetInnerHTML={{__html: data?.description}}/>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
